// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/stickyHeader/stickyHeader.js#1 $

/**
* @ngdoc directive
* @name tcApp.directive:tcDate
* @description
* Date picker
*/

/* @flow */
/* jshint loopfunc: true */
angular.module('tc.stickyheader', [])
.value('tcStickyheaderOptions', {
	STICKY: 'tc-sticky-table-header__original',
	CLONE: 'tc-sticky-table__clone',
	CLONE_VISIBLE: 'tc-sticky-table__clone--visible',
	CLONE_ID: '-clone'
})
.directive('tcStickyheader', function($window, $timeout, $document, tcStickyheaderOptions, GlobalService, tcConstants) {
	return {
		restrict: 'A',
		priority: -1, // Compile after all other directives
		compile: function(element) {
			var overlayElement = $window.document.getElementsByClassName('md-panel tcOverlay')[0];
			if (overlayElement) return;
			
			var thead = element.find('thead');
			if (!thead[0]) return;
			var cloneHead = thead.clone(true, true);
			if ((angular.isDefined(cloneHead[0])) && (angular.isDefined(cloneHead[0].firstChild))) {
				cloneHead[0].firstChild.removeAttribute('tc-shortcutkey-childof');
			}
			cloneHead.addClass(tcStickyheaderOptions.CLONE);
			cloneHead.attr('id', (element[0].id + tcStickyheaderOptions.CLONE_ID));
			cloneHead.attr('role', 'presentation');
			cloneHead.attr('aria-hidden', 'true');
			var cloneRow = cloneHead.children()[0];
			if (cloneRow) {
				cloneRow = angular.element(cloneRow);
				cloneRow.attr('id', (element[0].id + '-row' + tcStickyheaderOptions.CLONE_ID));
				cloneRow.attr('tc-shortcutkey-childof', 'L');
			}

			// Prevent duplicate ids for cloned header & child elements
			var cloneHeadTags = cloneHead[0].querySelectorAll('[id]');
			angular.forEach(cloneHeadTags, function(thClone) {
				thClone = angular.element(thClone);
				thClone.attr('id', thClone[0].id + tcStickyheaderOptions.CLONE_ID);
				thClone.attr('tabIndex', '-1');
			});

			thead.after(cloneHead);

			// return link function
			return function(scope, element) {
				var options = tcStickyheaderOptions;
				var table = element;

				// Chack that we have both original and clone
				var tHeadArray = element.find('thead');
				if (!tHeadArray[0]) return;
				var thead = angular.element(tHeadArray[0]);
				if (!tHeadArray[1]) return;
				var clone = angular.element(tHeadArray[1]);
				var scrollable = null;

				var initialise = function() {
						if (!thead[0]) return;
						scrollable = GlobalService.getScrollableParent(table[0]);
						scrollable = angular.element(scrollable);
						scrollable.on('scroll resize', scroll);
						angular.element($window).on('resize', styleClone);
					};

				var scroll = function() {
						if (table[0].offsetHeight === 0) return;
						
						var scrollableRect = scrollable[0].getBoundingClientRect();
						var tableRect = table[0].getBoundingClientRect();

						if (!thead.hasClass(options.STICKY) && (scrollableRect.top > tableRect.top)
							&& ((scrollableRect.top + thead[0].offsetHeight - 2) < tableRect.bottom)
						) {
							stick();
						}

						if (thead.hasClass(options.STICKY) && (
							(scrollableRect.top < tableRect.top)
							|| ((scrollableRect.top + thead[0].offsetHeight - 2) > tableRect.bottom)
						)) {
							unstick();
						}
						
						// move clone when scrolling horizontally so it lines up properly with columns
						if (clone !== null) clone.css({'left': (tableRect.left) + 'px'});

						return true;
					};

				var stick = function() {					
					styleClone();
					clone.addClass(options.CLONE_VISIBLE);
					thead.addClass(options.STICKY);
				};
					
				var unstick = function() {
					thead.removeClass(options.STICKY);
					clone.removeClass(options.CLONE_VISIBLE);
				};
					
				var styleClone = function() {
					if (clone === null) {
						return;
					}
					if (table[0].offsetHeight === 0) return;
					var tableRect = table[0].getBoundingClientRect(); 
					var stickyElement = scrollable[0].querySelector('.componentRowSticky');
					var stickyOffset = (stickyElement ? (stickyElement.clientHeight - tcConstants.DIMENSIONS.STICKY_ROW_OFFSET) : 0);
					clone.css({
						'visibility': 'visible',
						'top': (scrollable[0].offsetTop - 1 + stickyOffset) + 'px',
						'width': (tableRect.width) + 'px',
						'left': (tableRect.left) + 'px'
					});

					if (options && options.nestedLevel) {
						// For nested lists: Increment z-index and add a box-shadow to cover the parent header
						// 22px is same margin used in 'td.componentTableNestedList'
						clone.css({
							boxShadow: '-22px 0px 0px 0px #e7e7e7',
							// (border-collapse & spacing is required for IE11, even though it changes the borders/padding slightly)
							borderCollapse: 'separate',
							borderSpacing: 0,
							zIndex: options.nestedLevel + 2
						});
					}

					var th = thead.find('th');
					angular.forEach(clone.find('th'), function(thClone, thCloneIndex) {
						if (th[thCloneIndex]) {
							angular.element(thClone).css({
								width: $window.getComputedStyle(th[thCloneIndex]).width
							});
						}
					});
				};

				var destroy = function() {
					if (scrollable !== null) scrollable.off('scroll resize', scroll);
					angular.element($window).off('resize', styleClone);
				};
					
				// do not initialise until document is ready to avoid issues with getScrollableContainer
				angular.element(function() {
					initialise();
				});
				
				scope.$on('StickyHeader:ReClone', function(event, msDelay) {
					if (clone !== null) {
						// Increase delay in cases where page needs more time to render (e.g. dynamic columns)
						msDelay = (msDelay || 50);
						$timeout(styleClone, msDelay);
					}
				});
				
				// Called from componenCtrl to get Clone boundingRect
				scope.$on('StickyHeader:GetClone', function(event, tableId, callbackFunction) {
					if ((angular.isUndefined(table)) || (table[0].id !== tableId)) return;
					if (clone !== null) {
						if (angular.isFunction(callbackFunction)) {
							callbackFunction(clone[0]);
						}	
					}
				});
				
				scope.$on('$destroy', destroy);
			};
		}
	};
});
